import { registerPlugin } from '@capacitor/core';

import type { CapacitorVideoCompressionPlugin } from './definitions';

const CapacitorVideoCompression = registerPlugin<CapacitorVideoCompressionPlugin>(
  'CapacitorVideoCompression',
  {
    web: () => import('./web').then((m) => new m.CapacitorVideoCompressionWeb()),
  },
);

export * from './definitions';
export { CapacitorVideoCompression };
